export default {
  created() {
    this.$nextTick(() => {
      const width = window.innerWidth;
      document.getElementById('agreement').style.width = width + 'px';
    });
  }
};
